export default {
    namespaced: true,
    state: {
        name: 'VehicleParkEstimate',
		endpoint: '/vehicle/park/estimate',
        items: [],
    },
}